export default __webpack_public_path__ + "static/media/upload_white.5209c993.svg";